import dagre from '@moleculeone/dagre-plus';
import { V4 } from '@moleculeone/utils';
import { Mol } from '@moleculeone/types';
import { mapValues } from 'lodash';

import { createInitialGraphLayout, prepareGraphEdges, prepareGraphNodes, prepareNodes } from './graph';
import { createAtomMapping } from './mapping';
import { createReactionLinkData } from './tree';

const graphSettings = {
  rankdir: 'LR',
  nodesep: 140,
  ranker: 'tight-tree',
  ranksep: 200,
};

const MOLECULE_MARGIN = V4.vect(200, 75);

interface PrepareTreeArgs {
  tree: any;
  renderPointContext?: any;
  molCache?: any;
  smilesToMol: (smiles: string) => Promise<Mol>;
  canvas?: any;
  synthesis?: any;
}

export async function prepareTree({
  tree,
  renderPointContext = {},
  molCache = {},
  smilesToMol,
  canvas,
  synthesis,
}: PrepareTreeArgs) {
  const graph = new dagre.graphlib.Graph();
  graph.setGraph({});
  graph.setDefaultEdgeLabel(() => ({}));
  graph.setGraph(graphSettings);

  const mapping = createAtomMapping(tree);
  const initialNodes: any = await prepareNodes({
    tree,
    mapping,
    molCache,
    margin: MOLECULE_MARGIN,
    smilesToMol,
    canvas,
  });

  createInitialGraphLayout(initialNodes, graph, mapping);

  const nodes: any = prepareGraphNodes(initialNodes, graph);

  const reactionLinkData = createReactionLinkData(tree, []);

  const edges = prepareGraphEdges({
    nodes,
    graph,
    tree,
    margin: MOLECULE_MARGIN,
    reactionLinkData,
    renderPointContext,
    synthesis,
  });

  return {
    nodes,
    edges,
    mapping,
    molCache: {
      ...mapValues(initialNodes, node => node.mol),
      ...molCache,
    },
  };
}
